import { useEffect } from "react";
import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ErrorState } from "@/components/ui/error-state";
import { useComparisonsStore } from "@/stores/comparisons";
import { HistoryTable } from "./HistoryTable";

export function HistoryView() {
  const { history, loading, error, fetchHistory } = useComparisonsStore();

  useEffect(() => {
    fetchHistory();
  }, []);

  return (
    <div className="space-y-6">
      {/* Actions Bar */}
      {history.length > 0 && (
        <div className="flex items-center justify-between">
          <p className="text-[13px] text-slate-500">
            {history.length} comparison{history.length !== 1 ? "s" : ""}
          </p>
          <Button variant="secondary" size="sm" asChild>
            <a href="/api/export/csv" download>
              <Download className="h-4 w-4 mr-1.5" />
              Export CSV
            </a>
          </Button>
        </div>
      )}

      {loading ? (
        <div className="space-y-3">
          {[1, 2, 3, 4, 5].map((i) => (
            <div
              key={i}
              className="h-12 bg-white border border-slate-200 rounded-md animate-subtle-pulse"
            />
          ))}
        </div>
      ) : error ? (
        <ErrorState message={error} onRetry={fetchHistory} />
      ) : (
        <HistoryTable comparisons={history} />
      )}
    </div>
  );
}
